import * as Sentry from '@sentry/vue'

// Sentry поднимается только если задан DSN. Без VUE_APP_SENTRY_DSN
// (локальная разработка, сборки без переменной) — полный no-op.
export function initSentry(app, router) {
  const dsn = process.env.VUE_APP_SENTRY_DSN
  if (!dsn) return

  // Performance-трейсинг по умолчанию выключен — задача про ошибки.
  // Интеграцию навигации подключаем только при ненулевом sample rate.
  const tracesSampleRate = Number(process.env.VUE_APP_SENTRY_TRACES_SAMPLE_RATE) || 0

  Sentry.init({
    app,
    dsn,
    environment: process.env.VUE_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    integrations: tracesSampleRate > 0 ? [Sentry.browserTracingIntegration({ router })] : [],
    tracesSampleRate,
    sendDefaultPii: false,
  })
}
